import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { inputStyles, labelStyles, requiredStyles } from '../styles';
import Select from 'react-select';

interface Props {
    metadata: any;
    roleOptions: any;
    teamMember?: any;
}

const RelationshipAndRole: React.FC<Props> = ({ metadata, roleOptions }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();
    const isForOptions = metadata.campaign_is_for.map((isFor) => {
        return { value: isFor.id, label: isFor.name };
    });
    return (
        <>
            <label
                htmlFor='cid-relationship_to_patient_id'
                className={labelStyles}
            >
                Relationship to Client<span className={requiredStyles}>*</span>
            </label>
            <Controller
                name='relationship_to_patient_id'
                rules={{ required: true }}
                control={control}
                render={({ field }) => (
                    <Select
                        menuPlacement='auto'
                        options={isForOptions}
                        value={field.value || null}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        isClearable
                        className='w-full'
                    />
                )}
            />
            {errors.relationship_to_patient_id?.type && (
                <p style={{ color: '#ff4b4b' }} className=' mt-1 text-sm'>
                    This field is required
                </p>
            )}

            <label htmlFor='td-role' className={labelStyles}>
                Role<span className={requiredStyles}>*</span>
            </label>
            {roleOptions.map((role) => (
                <div key={role.value} className='mt-[12px]'>
                    <div className='align-center flex gap-[12px]'>
                        <Controller
                            name='role'
                            rules={{ required: true }}
                            control={control}
                            render={({ field }) => (
                                <input
                                    id={`td-${role.value}`}
                                    type='radio'
                                    value={role.value}
                                    checked={field.value === role.value}
                                    onChange={() => field.onChange(role.value)}
                                    className='mt-[2px] h-[18px] w-[18px]'
                                />
                            )}
                        />
                        <label htmlFor={`td-${role.value}`}>{role.label}</label>
                    </div>
                    <div className='ml-[28px] mt-[12px] bg-[#F4F4F5] p-[12px]'>
                        {role.description}
                    </div>
                </div>
            ))}
            {errors.role?.type && (
                <p style={{ color: '#ff4b4b' }} className=' mt-1 text-sm'>
                    This field is required
                </p>
            )}

            <label
                htmlFor='td-role'
                className={`${labelStyles} mb-[12px] mt-[16px]`}
            >
                Check all that apply
            </label>

            <div className={`${labelStyles} flex gap-2`}>
                <Controller
                    name='is_primary_contact'
                    control={control}
                    render={({ field }) => (
                        <input
                            checked={field?.value}
                            id='cid-is_primary_contact'
                            type='checkbox'
                            {...field}
                        />
                    )}
                />
                <label htmlFor='cid-is_primary_contact' className='mr-1'>
                    Primary Contact
                </label>
            </div>

            <div className={`${labelStyles} flex gap-2`}>
                <Controller
                    name='is_emergency_contact'
                    control={control}
                    render={({ field }) => (
                        <input
                            checked={field?.value}
                            id='cid-is_emergency_contact'
                            type='checkbox'
                            {...field}
                        />
                    )}
                />
                <label htmlFor='cid-is_emergency_contact' className='mr-1'>
                    Emergency Contact
                </label>
            </div>

            <div className={`${labelStyles} flex gap-2`}>
                <Controller
                    name='can_discuss_balance'
                    control={control}
                    render={({ field }) => (
                        <input
                            checked={field?.value}
                            id='cid-can_discuss_balance'
                            type='checkbox'
                            {...field}
                        />
                    )}
                />
                <label htmlFor='cid-can_discuss_balance' className='mr-1'>
                    Inquire about Available Funds
                </label>
            </div>

            <div className={`${labelStyles} flex gap-2`}>
                <Controller
                    name='can_request_disbursement'
                    control={control}
                    render={({ field }) => (
                        <input
                            checked={field?.value}
                            id='cid-can_request_disbursement'
                            type='checkbox'
                            {...field}
                        />
                    )}
                />
                <label htmlFor='cid-can_request_disbursement' className='mr-1'>
                    Request Disbursement
                </label>
            </div>

            <label htmlFor='cid-notes' className={labelStyles}>
                Notes
            </label>
            <Controller
                name='notes'
                control={control}
                render={({ field }) => (
                    <textarea
                        id='cid-notes'
                        {...field}
                        className={`${inputStyles} w-full`}
                    />
                )}
            />
        </>
    );
};

export default RelationshipAndRole;
